import * as storeNS from '@/store/namespace';
import * as NS from './namespace';
import { ActionContext } from 'vuex';
import { HttpService, authHeader } from '@/services/http-service';

const actions: NS.IAuthActions = {
    resetForm({ commit, state }: ActionContext<NS.IAuthState, storeNS.IState>, payload: any): void {
        // очистим состояние формы
        commit('SET_FORM_REQUEST_RESET');
    },
    async logout({ commit, state }: ActionContext<NS.IAuthState, storeNS.IState>, payload: any): Promise<boolean> {
        try {
            // запрос на выход из системы
            await HttpService.post<NS.IAuthResponse>('/auth/logout');
            // Удалим из локального хранилища токен и пользователя
            localStorage.removeItem('user-token');
            localStorage.removeItem('user-obj');
            // Удалим дефолтный заголовок с аутентицикацией
            delete HttpService.defaults.headers.common[authHeader];
            // очистим состояние хранилища
            commit('SET_LOGOUT_SUCCESS');
            return true;
        } catch (ex) {
            return false;
        }
        
    },
    async login({ commit, state }: ActionContext<NS.IAuthState, storeNS.IState>, payload: NS.IAuthForm): Promise<boolean> {
        // установим состояние активного запроса
        commit('SET_FORM_REQUEST');

        try {
            // Запрос на авторизацию
            const res = await HttpService.post<NS.IAuthResponse>('/auth/login', payload);
            // сохраним пользователя и токен в локальное хранилище
            localStorage.setItem('user-token', res.data.token);
            localStorage.setItem('user-obj', JSON.stringify(res.data.user));
            // Установим заголовок с токеном по дефолту
            HttpService.defaults.headers.common[authHeader] = res.data.token;
            // Передадим информацию об аутентификации хранилищу vuex
            commit('SET_LOGIN_SUCCESS', res.data);
            return true;
        } catch (ex) {
            // очистим локальное хранилище
            localStorage.removeItem('user-token');
            localStorage.removeItem('user-obj');
            // очистим дефолтный заголовок
            delete HttpService.defaults.headers.common[authHeader];
            // установим состояние ошибки для хранилища
            commit('SET_FORM_REQUEST_FAIL');
            return false;
        }
    },
    cleanAuth({ commit, state }: ActionContext<NS.IAuthState, storeNS.IState>): boolean {
        try {
            // Очистим локальное хранилище
            localStorage.removeItem('user-token');
            localStorage.removeItem('user-obj');
            // очистим дефолтный заголвок
            delete HttpService.defaults.headers.common[authHeader];
            // очистим состояние vuex
            commit('SET_LOGOUT_SUCCESS');
            return true;
        } catch (ex) {
            return false;
        }
    },
}

/**
 * Реализация действий модуля аутентицикации
 */
export default actions;